<template lang="pug">
#modal-header-declaracao-jurada
    el-dialog.modal-header-declaracao-jurada-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='50%'
    )
        h1(slot='title') {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.titulo') }}

        .modal-header-declaracao-jurada-content__container(
            ref='scrollContainer',
            @scroll='handleScroll'
        )
            .container
                h2.description {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.descricao') }}

                .information
                    strong {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.acopoio') }}:
                    strong {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.subscribe') }},
                    strong {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.pessoa') }}:
                    strong {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.razaoSocial') }} {{ razonSocial }}
                    strong RUC: {{ ruc }}
                    strong {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.data') }} {{ getDataAtualFormatada() }}

                .texto
                    h3.titulo {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.declaro') }}
                    .text
                        p
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.textoUm') }}
                            strong.bold {{ trading }},
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.textoDois') }}
                            strong.bold {{ numeroContrato }}
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.textoTres') }}

                        p {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.comprometimento') }}

                    h3.titulo 1. {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.deflorestacao') }}
                    .text
                        p {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.textoDeflorestacao') }}

                    h3.titulo 2. {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidade') }}
                    .text
                        p {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoUm') }}
                        p {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoDois') }}
                        p {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoTres') }}
                        p
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoQuatro') }}
                            strong.bold {{ trading }}
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoCinco') }}
                        p
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoSeis') }}
                            strong.bold {{ trading }}
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoSete') }}
                            strong.bold {{ trading }}
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoOito') }}
                        p
                            | {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.rastreabilidadeTextoNove') }}
                            strong.bold {{ trading }}.

        .footer
            el-checkbox(v-model='checkboxValue', :disabled='!checkboxEnabled') {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.termos') }}
            span.btn-download(
                @click='downloadTermoDeclaracaoJuradaSubempresa()',
                v-if='checkboxValue'
            )
                i.mdi.mdi-download
                span {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.download') }}
            .buttons
                el-button(type='primary', @click='voltar')
                    i.mdi.mdi-arrow-left(style='margin-right: 5px')
                    | {{ $t('mensagens.comuns.voltar') }}
                el-button(
                    type='primary',
                    @click='aceitarTermos',
                    :disabled='!checkboxEnabled || !checkboxValue'
                )
                    | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';

export default {
    name: 'ModalDeclaracaoJurada',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        razonSocial: {
            type: String,
            required: true,
            default: ''
        },
        ruc: {
            type: String,
            required: true,
            default: ''
        },
        trading: {
            type: String,
            required: true,
            default: ''
        },
        numeroContrato: {
            type: String,
            required: true,
            default: ''
        }
    },

    data() {
        return {
            checkboxEnabled: false,
            checkboxValue: false
        };
    },

    methods: {
        handleScroll() {
            const container = this.$refs.scrollContainer;
            if (!container) return;

            const threshold = 10;
            const isBottomReached =
                container.scrollTop + container.clientHeight >=
                container.scrollHeight - threshold;

            if (isBottomReached && !this.checkboxEnabled) {
                this.checkboxEnabled = true;
            }
        },
        voltar() {
            this.$router.go(-1);
        },
        getDataAtualFormatada() {
            const hoje = new Date();
            const dia = String(hoje.getDate()).padStart(2, '0');
            const mes = String(hoje.getMonth() + 1).padStart(2, '0');
            const ano = hoje.getFullYear();
            return `${dia}/${mes}/${ano}`;
        },

        async aceitarTermos() {
            try {
                await ContratoOriginacaoServiceSubEmpresa.aceitarTermo(
                    this.numeroContrato
                );

                this.$message.success(
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.sucesso'
                    )
                );
                this.$emit('refetch');
            } catch (error) {
                this.$message.error(
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.declaracao.erro'
                    )
                );
            }
        },

        async downloadTermoDeclaracaoJuradaSubempresa() {
            const response =
                await ContratoOriginacaoServiceSubEmpresa.downloadTermoDeclaracaoJuradaSubempresa(
                    this.numeroContrato
                );

            if (response) {
                const blob = new Blob([response.data], {
                    type: 'application/pdf'
                });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = 'termo-declaracion-jurada.pdf';
                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);
            }
        }
    }
};
</script>

<style lang="scss">
#modal-header-declaracao-jurada {
    .el-dialog__header h1 {
        font-size: 1.25rem;
        font-weight: bolder;
    }

    .el-dialog__body {
        padding: 0 25px 0 5px !important;
    }

    .modal-header-declaracao-jurada-content__container {
        height: 50vh;
        overflow: auto;
        margin-top: 2rem;

        .container {
            display: grid;
            gap: 1rem;

            .description {
                font-size: 1.15rem;
                font-weight: 400;
                color: var(--primary-font-color);
            }

            .information {
                display: grid;
            }

            .texto {
                display: grid;

                .titulo {
                    color: black;
                }

                .text {
                    p {
                        color: black;

                        strong {
                            font-weight: bold;
                            margin: 0 3px;
                        }
                    }
                }
            }
        }
    }

    .footer {
        width: 100%;
        padding: 0 1rem 2rem 1rem;
        display: grid !important;
        gap: 1.5rem;

        .btn-download {
            cursor: pointer;
            display: flex;
            gap: 5px;
            font-weight: 600;
            font-size: 14px;

            i {
                font-size: 15px;
            }

            span {
                text-decoration: underline;
                color: var(--primary);
            }
        }

        .el-button {
            width: fit-content;
        }
    }
}

.modal-header-declaracao-jurada-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }

    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }

    .buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;

        button {
            padding: 8px 20px !important;
        }
    }

    .container-header-table__infor {
        margin-bottom: 18px;

        .el-alert__title {
            color: #3b3b3b !important;
        }
    }

    .container-header-table {
        h4 {
            margin-bottom: 16px;
        }

        .el-table {
            border-top-right-radius: 11px;
            border-top-left-radius: 11px;
            min-height: 140px;

            thead.has-gutter {
                th.el-table__cell {
                    background-color: #fbfbfb;
                }
            }

            .descricao-item-tabela {
                margin-left: 55px;
                margin-right: 55px;
            }

            .el-table .cell .el-checkbox__inner {
                padding: 0px;
            }
        }
    }

    .container-header-pagination {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .spans-paginacao {
            display: flex;
            gap: 21px;
            color: #183b57;
            font-weight: bold;
        }
    }
}
</style>
